import React from 'react';
import _ from 'lodash';

import { useInventoryActivity_TemplateTabQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface ITemplateGroup {
  id: string;
  createdTimestamp: DateTime;
  name: string;
  templateCount: number;
}

export interface IData {
  templates: ITemplateGroup[];
}

export function useQuery() {
  const tuple = useInventoryActivity_TemplateTabQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        templates: _.map(tuple.data?.listingManagementStrategyTemplateGroups.nodes ?? [], (group): ITemplateGroup => ({
          id: group.id,
          name: group.name,
          createdTimestamp: DateTime.fromISO(group.createdTimestamp),
          templateCount: group.templateCount
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
